module.exports = __webpack_public_path__ + "img/开料机.b91b43b7.jpg";